import { compileMessage } from './compile-message.filter';
import { currency } from './currency.filter';

export const FILTERS_REGISTRY = {
  compileMessage,
  currency,
  facetCurrency: currency
};
